import { render, staticRenderFns } from "./alarmSetting.vue?vue&type=template&id=ff84d2f8&scoped=true&"
import script from "./alarmSetting.vue?vue&type=script&lang=js&"
export * from "./alarmSetting.vue?vue&type=script&lang=js&"
import style0 from "./alarmSetting.vue?vue&type=style&index=0&id=ff84d2f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff84d2f8",
  null
  
)

export default component.exports